// modules
import { createAction } from 'redux-actions'

// actions
export const setCaregiverProfile = createAction('SET_CAREGIVER_PROFILE')
export const resetCaregiverProfile = createAction('RESET_CAREGIVER_PROFILE')
